import { TooltipItem } from "chart.js";

export interface ChartTooltipData {
  labels: string[];
  values: number[];
  percentages: number[];
}

export const createChartTooltipStyles = () => ({
  backgroundColor: "#001E4C", // Dark blue background
  titleColor: "#FFFFFF",
  bodyColor: "#FFFFFF",
  borderColor: "#001E4C",
  borderWidth: 0,
  cornerRadius: 8,
  displayColors: false,
  padding: 12,
  titleFont: {
    size: 12,
    weight: "normal" as const,
  },
  bodyFont: {
    size: 14,
    weight: "bold" as const,
  },
});

export const createChartTooltipCallbacks = (data: ChartTooltipData) => ({
  title: function (tooltipItems: TooltipItem<"doughnut">[]) {
    const tooltipItem = tooltipItems[0];
    const label = data.labels[tooltipItem.dataIndex] || "Unknown";
    const percentage = data.percentages[tooltipItem.dataIndex] || 0;
    return `${label} (${percentage}%)`;
  },
  label: function (tooltipItem: TooltipItem<"doughnut">) {
    const dataIndex = tooltipItem.dataIndex;
    const value = data.values[dataIndex];
    return `${value} users`;
  },
});

export interface RoleDataItem {
  value: number;
  label: string;
}

export const createRoleDataStructure = (
  contractors: number,
  oems: number,
  admins: number
): RoleDataItem[] => [
  { value: contractors, label: "Contractors" },
  { value: oems, label: "OEM" },
  { value: admins, label: "Administrators" },
];
